/* VanillaGoods Dessert Builder page (vgb-builder.js): renders the steps, the options and the composed recipe
   using VGB.core (vgb-core.js) and the data file. State lives in the URL hash so a dessert is shareable;
   saves go to localStorage key vg_desserts_v1 (My Kitchen syncs it once the key is whitelisted). ASCII only. */
(function () {
  'use strict';
  var root = document.querySelector('[data-vgb]');
  if (!root || !window.VGB || !window.VGB.core) return;
  var C = window.VGB.core;
  var SAVE_KEY = 'vg_desserts_v1';
  var SLOT_LIMIT = 18;

  var idx = null, state = {}, details = {}, pending = {}, expanded = {}, queries = {}, mode = 'parts', have = {};
  var els = {
    steps: root.querySelector('[data-vgb-steps]'), result: root.querySelector('[data-vgb-result]'),
    classics: root.querySelector('[data-vgb-classics]'), chips: root.querySelector('[data-vgb-classic-chips]'),
    gearBox: root.querySelector('[data-vgb-gear-box]'), gear: root.querySelector('[data-vgb-gear]'),
    savedBox: root.querySelector('[data-vgb-saved-box]'), saved: root.querySelector('[data-vgb-saved]'),
    count: root.querySelector('[data-vgb-count]'), toast: root.querySelector('[data-vgb-toast]'),
    vanillaNote: root.querySelector('[data-vgb-vanilla-note]')
  };
  var photos = {};
  try { photos = JSON.parse((document.querySelector('[data-vgb-photos]') || {}).textContent || '{}') || {}; } catch (e) { photos = {}; }

  /* ------------------------------------------------------------------ helpers --- */

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function h(tag, attrs, html) {
    var el = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) { if (attrs[k] != null && attrs[k] !== false) el.setAttribute(k, attrs[k] === true ? '' : attrs[k]); });
    if (html != null) el.innerHTML = html;
    return el;
  }
  function img(url, w) {
    if (!url) return '';
    var u = url.indexOf('?') === -1 ? url + '?width=' + w : url.replace(/([?&])width=\d+/, '$1width=' + w);
    if (u.indexOf('width=') === -1) u += '&width=' + w;
    return '<img src="' + esc(u) + '" alt="" loading="lazy" decoding="async">';
  }
  function minutes(m) { m = +m || 0; if (m < 60) return m + ' min'; var hh = Math.floor(m / 60), mm = m % 60; return hh + ' hr' + (hh > 1 ? 's' : '') + (mm ? ' ' + mm + ' min' : ''); }
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* none */ } }
  function toast(msg) {
    if (!els.toast) return;
    els.toast.textContent = msg; els.toast.setAttribute('data-on', '1');
    clearTimeout(toast.t); toast.t = setTimeout(function () { els.toast.removeAttribute('data-on'); }, 2200);
  }
  function type() { return state.type ? idx.types[state.type] : null; }
  /** The component's photo on the dessert being built when one exists, else its recipe photo. */
  function pic(c) { return (c.ii && state.type && c.ii[state.type]) || c.i; }
  function writeHash() {
    var hash = C.toHash(state);
    if (hash !== location.hash) { try { history.replaceState(null, '', location.pathname + location.search + hash); } catch (e) { location.hash = hash; } }
  }
  function ls() { try { return window.localStorage; } catch (e) { return null; } }
  function readSaves() { var s = ls(); if (!s) return {}; try { return JSON.parse(s.getItem(SAVE_KEY) || '{}') || {}; } catch (e) { return {}; } }

  /* ------------------------------------------------------------------ classics --- */

  function renderClassics() {
    if (!els.chips || !idx.data.classics.length) return;
    els.chips.innerHTML = '';
    idx.data.classics.forEach(function (c) {
      var b = h('button', { type: 'button', 'class': 'vgb-chip', 'aria-pressed': 'false' }, esc(c.name));
      b.addEventListener('click', function () {
        state = {}; Object.keys(c).forEach(function (k) { if (k !== 'name') state[k] = c[k]; });
        state.servings = idx.types[c.type].servings;
        track('builder_classic', { name: c.name });
        render();
        var r = els.result; if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      els.chips.appendChild(b);
    });
    els.classics.hidden = false;
  }

  /* ------------------------------------------------------------------ steps --- */

  function stepEl(title, body, done, meta) {
    var li = h('li', { 'class': 'vgb-step', 'data-done': done ? '1' : '0' });
    var head = h('div', { 'class': 'vgb-step__head' }, '<h2>' + esc(title) + '</h2>' + (meta ? '<span class="vgb-step__req">' + esc(meta) + '</span>' : ''));
    li.appendChild(head);
    var b = h('div', { 'class': 'vgb-step__body' });
    if (typeof body === 'string') b.innerHTML = body; else b.appendChild(body);
    li.appendChild(b);
    return li;
  }

  function typesStep() {
    var grid = h('div', { 'class': 'vgb-types', role: 'group', 'aria-label': 'Dessert type' });
    idx.data.types.forEach(function (t) {
      var b = h('button', { type: 'button', 'class': 'vgb-type', 'aria-pressed': state.type === t.key ? 'true' : 'false' },
        '<strong>' + esc(t.name) + '</strong><small>' + esc(t.blurb) + '</small>');
      b.addEventListener('click', function () {
        if (state.type === t.key) return;
        state = { type: t.key, servings: t.servings };
        track('builder_start', { type: t.key });
        render();
      });
      grid.appendChild(b);
    });
    return stepEl('What are you making?', grid, !!state.type);
  }

  function optionCard(o, slot) {
    var c = o.comp;
    var b = h('button', { type: 'button', 'class': 'vgb-opt', 'aria-pressed': state[slot.key] === c.h ? 'true' : 'false', disabled: !o.ok, title: o.why || '' });
    var meta = [c.f && c.f !== 'Classic' ? c.f : '', c.m ? minutes(c.m) : ''].filter(Boolean).join(' \u00b7 ');
    var badge = '';
    if (!o.ok) badge = '<span class="vgb-badge vgb-badge--why">' + esc(o.why) + '</span>';
    else if (o.all) badge = '<span class="vgb-badge">Pairs well</span>';
    b.innerHTML = '<span class="vgb-opt__img">' + img(pic(c), 480) + '</span><span class="vgb-opt__b"><span class="vgb-opt__t">' + esc(c.t) + '</span>' +
      (meta ? '<span class="vgb-opt__m">' + esc(meta) + '</span>' : '') + badge + '</span>';
    b.addEventListener('click', function () {
      if (!o.ok) return;
      state[slot.key] = c.h;
      if (o.note) toast(o.note);
      track('builder_pick', { type: state.type, slot: slot.key, recipe: c.h });
      render();
      var next = els.steps.querySelector('.vgb-step[data-done="0"]');
      if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return b;
  }

  function slotStep(t, slot) {
    var chosen = state[slot.key] ? idx.byHandle[state[slot.key]] : null;
    var body = h('div');
    if (chosen) {
      var a = C.allowed(idx, t, slot, chosen, state);
      var card = h('div', { 'class': 'vgb-chosen' }, img(pic(chosen), 240) + '<span><span class="vgb-chosen__t">' + esc(chosen.t) + '</span><br><span class="vgb-chosen__m">' +
        esc([chosen.f && chosen.f !== 'Classic' ? chosen.f : '', chosen.m ? minutes(chosen.m) : ''].filter(Boolean).join(' \u00b7 ')) +
        (a.ok ? '' : ' \u00b7 <span class="vgb-badge vgb-badge--why">' + esc(a.why) + '</span>') + (a.note ? '</span><br><span class="vgb-badge vgb-badge--note">' + esc(a.note) : '') + '</span></span>');
      var x = h('button', { type: 'button', 'class': 'vgb-chosen__x' }, 'Change');
      x.addEventListener('click', function () { delete state[slot.key]; render(); });
      card.appendChild(x);
      body.appendChild(card);
      return stepEl(slot.label, body, a.ok, slot.required ? '' : 'optional');
    }
    var search = h('div', { 'class': 'vgb-search' }, '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>');
    var input = h('input', { type: 'search', placeholder: 'Search ' + slot.label.toLowerCase() + '...', 'aria-label': 'Search ' + slot.label, value: queries[slot.key] || '', autocomplete: 'off' });
    search.appendChild(input);
    body.appendChild(search);
    var grid = h('div', { 'class': 'vgb-opts' });
    body.appendChild(grid);
    var more = h('button', { type: 'button', 'class': 'vgb-more' });
    body.appendChild(more);
    function fill() {
      var opts = C.options(idx, t, slot.key, state, queries[slot.key]);
      grid.innerHTML = '';
      var lim = expanded[slot.key] ? opts.length : SLOT_LIMIT;
      opts.slice(0, lim).forEach(function (o) { grid.appendChild(optionCard(o, slot)); });
      if (!opts.length) grid.innerHTML = '<p class="vgb-note">Nothing matches that search.</p>';
      more.hidden = opts.length <= SLOT_LIMIT;
      more.textContent = expanded[slot.key] ? 'Show fewer' : 'Show all ' + opts.length;
    }
    more.addEventListener('click', function () { expanded[slot.key] = !expanded[slot.key]; fill(); });
    input.addEventListener('input', function () { queries[slot.key] = input.value; fill(); });
    fill();
    if (!slot.required) {
      var skip = h('p', { 'class': 'vgb-skip' }, 'Optional: <button type="button">skip this</button>');
      skip.querySelector('button').addEventListener('click', function () { state[slot.key] = ''; render(); });
      body.appendChild(skip);
    }
    var done = !slot.required && state[slot.key] === '';
    if (done) {
      body.innerHTML = '<p class="vgb-skip">Skipped. <button type="button">Add one</button></p>';
      body.querySelector('button').addEventListener('click', function () { delete state[slot.key]; render(); });
    }
    return stepEl(slot.label, body, done, slot.required ? '' : 'optional');
  }

  function servingsStep(t) {
    var wrap = h('div', { 'class': 'vgb-servings' });
    var n = state.servings || t.servings;
    wrap.innerHTML = '<label for="vgb-n">How many ' + esc(t.noun === 'pie' || t.noun === 'cheesecake' || t.noun === 'layer cake' ? 'slices' : t.noun) + '?</label>' +
      '<button type="button" aria-label="Fewer">\u2212</button><input id="vgb-n" type="number" min="2" max="96" step="1" value="' + n + '"><button type="button" aria-label="More">+</button>' +
      '<small>The recipe is written for ' + t.servings + ' (' + esc(t.pan) + ').</small>';
    var input = wrap.querySelector('input'), btns = wrap.querySelectorAll('button');
    function set(v) { v = Math.max(2, Math.min(96, parseInt(v, 10) || t.servings)); state.servings = v; input.value = v; writeHash(); renderResult(); }
    btns[0].addEventListener('click', function () { set((+input.value || t.servings) - (t.servings >= 12 ? 4 : 2)); });
    btns[1].addEventListener('click', function () { set((+input.value || t.servings) + (t.servings >= 12 ? 4 : 2)); });
    input.addEventListener('change', function () { set(input.value); });
    return stepEl('How many?', wrap, true, '');
  }

  function render() {
    var t = type();
    els.steps.innerHTML = '';
    els.steps.appendChild(typesStep());
    if (t) {
      t.slots.forEach(function (s) { els.steps.appendChild(slotStep(t, s)); });
      els.steps.appendChild(servingsStep(t));
    }
    if (els.chips) [].forEach.call(els.chips.children, function (b) { b.setAttribute('aria-pressed', 'false'); });
    writeHash();
    renderGear();
    renderResult();
  }

  /* ------------------------------------------------------------------ details (recipe JSON) --- */

  function fetchDetail(handle) {
    if (details[handle]) return Promise.resolve(details[handle]);
    if (pending[handle]) return pending[handle];
    pending[handle] = fetch('/blogs/recipes/' + encodeURIComponent(handle) + '?view=vgb', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        d.ingredients = (d.ingredients || []).filter(function (l) { return l && (l.name || (l.text && l.text.trim())); });
        d.steps = (d.steps || []).filter(function (s) { return s && s.trim(); });
        details[handle] = d; delete pending[handle]; return d;
      })
      .catch(function (e) { delete pending[handle]; throw e; });
    return pending[handle];
  }

  /* ------------------------------------------------------------------ result --- */

  function renderResult() {
    var t = type(), r = els.result;
    if (!t) { r.hidden = true; return; }
    var chk = C.check(idx, t, state);
    r.hidden = false;
    if (!chk.complete) {
      var need = chk.missing.map(function (k) { return C.slot(t, k).label.toLowerCase(); });
      var bad = chk.conflicts.map(function (c) { return idx.byHandle[c.handle].t + ' (' + c.why + ')'; });
      r.innerHTML = '<p class="vgb-result__wait">' + (need.length ? 'Pick ' + esc(need.join(' and ')) + ' to see your recipe.' : '') +
        (bad.length ? ' Change ' + esc(bad.join('; ')) + '.' : '') + '</p>';
      return;
    }
    var handles = t.slots.map(function (s) { return state[s.key]; }).filter(Boolean);
    var missing = handles.filter(function (hh) { return !details[hh]; });
    if (missing.length) {
      r.innerHTML = '<p class="vgb-result__wait">Putting your recipe together\u2026</p>';
      Promise.all(missing.map(fetchDetail)).then(renderResult).catch(function () {
        r.innerHTML = '<p class="vgb-result__wait">One of the recipes did not load. <a href="' + esc(location.href) + '">Try again</a> or open the parts above directly.</p>';
      });
      return;
    }
    var out = C.compose(idx, t, state, details, state.servings);
    track('builder_complete', { type: t.key, title: out.title });
    var L = out.labels;
    var saves = readSaves(), key = C.toHash(state), saved = !!saves[key];
    var html = '<p class="vgb-eyebrow">Your dessert</p><h2 class="vgb-title">' + esc(out.title) + '</h2>' +
      '<p class="vgb-sub">' + esc(out.parts.map(function (p) { return p.title; }).join(' + ')) + '</p>' +
      '<div class="vgb-strip">' + out.parts.map(function (p) { return img(p.image, 240); }).join('') + '</div>' +
      '<div class="vgb-facts"><span>Makes <b>' + out.people + ' ' + esc(t.noun === 'cupcakes' || t.noun === 'doughnuts' ? t.noun : 'servings') + '</b></span>' +
      '<span>Active <b>' + minutes(L.prep + L.cook) + '</b></span>' + (L.wait ? '<span>Chill or rest <b>' + minutes(L.wait) + '</b></span>' : '') +
      '<span>Parts <b>' + out.parts.length + '</b></span></div>' +
      '<div class="vgb-labels">' + L.diets.map(function (d) { return '<span>' + esc(d.replace(/-/g, ' ')) + '</span>'; }).join('') +
      (L.allergens.length ? '<span class="vgb-labels__a">Contains ' + esc(L.allergens.join(', ').toLowerCase()) + (L.review ? ' (check labels)' : '') + '</span>' : '') +
      L.equipment.map(function (e) { return '<span>' + esc(e) + '</span>'; }).join('') + '</div>' +
      '<div class="vgb-actions"><button type="button" class="vgb-primary" data-act="save" aria-pressed="' + (saved ? 'true' : 'false') + '">' + (saved ? '\u2713 Saved to My Kitchen' : 'Save to My Kitchen') + '</button>' +
      '<button type="button" data-act="copy">Copy shopping list</button><button type="button" data-act="share">Copy link</button><button type="button" data-act="print">Print</button></div>';
    // ingredients
    html += '<section class="vgb-sec"><h3>Ingredients</h3><div class="vgb-toggle" role="group" aria-label="Ingredient view">' +
      '<button type="button" data-mode="parts" aria-pressed="' + (mode === 'parts') + '">By part</button><button type="button" data-mode="shop" aria-pressed="' + (mode === 'shop') + '">Shopping list</button></div>';
    if (mode === 'parts') {
      out.parts.forEach(function (p) {
        html += '<h4><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><small>' + esc(p.label) + (p.factor !== 1 ? ' \u00b7 ' + p.factor + '\u00d7 the recipe' : '') + '</small></h4><ul class="vgb-ings">';
        p.ingredients.forEach(function (l) {
          if (l.text) { html += '<li class="vgb-ings__h" style="font-weight:400">' + esc(l.text) + '</li>'; return; }
          if (l.heading && l.heading !== p.lastHeading) { p.lastHeading = l.heading; html += '<li class="vgb-ings__h">' + esc(l.heading) + '</li>'; }
          html += '<li><b>' + esc((l.amount + ' ' + l.unit).trim()) + '</b><span>' + esc(l.name) + (l.amount_metric ? ' <small>(' + esc(l.amount_metric + ' ' + l.unit_metric) + ')</small>' : '') + '</span></li>';
        });
        html += '</ul>';
      });
    } else {
      html += '<ul class="vgb-ings vgb-shop">';
      out.shopping.forEach(function (s, i) {
        var k = s.name + '|' + s.unit;
        html += '<li' + (have[k] ? ' class="vgb-have"' : '') + '><input type="checkbox" id="vgb-s' + i + '" data-have="' + esc(k) + '"' + (have[k] ? ' checked' : '') + '><b>' +
          esc((s.amount + ' ' + s.unit).trim() || (s.any ? 'as needed' : '')) + '</b><label for="vgb-s' + i + '">' + esc(s.name) + (s.metric ? ' <small>(' + esc(s.metric) + ')</small>' : '') +
          (s.from.length > 1 ? '<span class="vgb-from">for ' + esc(s.from.join(', ')) + '</span>' : '') + '</label></li>';
      });
      html += '</ul><p class="vgb-note">Tick what you already have. Amounts are the totals across every part.</p>';
    }
    html += '</section>';
    // method
    html += '<section class="vgb-sec vgb-method"><h3>Method</h3>';
    out.method.sections.forEach(function (s, i) {
      html += '<h4>' + (i + 1) + '. ' + esc(s.title) + '<small><a href="' + esc(s.url) + '">full recipe</a></small></h4><ol>' + s.steps.map(function (st) { return '<li>' + esc(st) + '</li>'; }).join('') + '</ol>';
    });
    html += '<h4>' + (out.method.sections.length + 1) + '. Put it together</h4><ol class="vgb-assembly">' + out.method.assembly.map(function (st) { return '<li>' + esc(st) + '</li>'; }).join('') + '</ol></section>';
    if (L.storage.length) html += '<section class="vgb-sec"><h3>Keeping it</h3><div class="vgb-storage">' + L.storage.map(function (s) { return '<p><b>' + esc(s.title) + ':</b> ' + esc(s.text) + '</p>'; }).join('') + '</div></section>';
    html += '<p class="vgb-note">Built from ' + out.parts.length + ' VanillaGoods recipes. Each part is tested on its own; the amounts are scaled to fit this ' + esc(t.noun) + ', so read the full recipe for a part before you start.</p>';
    r.innerHTML = html;
    r.querySelectorAll('[data-mode]').forEach(function (b) { b.addEventListener('click', function () { mode = b.getAttribute('data-mode'); renderResult(); }); });
    r.querySelectorAll('[data-have]').forEach(function (cb) { cb.addEventListener('change', function () { have[cb.getAttribute('data-have')] = cb.checked; cb.closest('li').classList.toggle('vgb-have', cb.checked); }); });
    r.querySelector('[data-act="save"]').addEventListener('click', function () { save(out, key); });
    r.querySelector('[data-act="copy"]').addEventListener('click', function () {
      var text = out.title + '\n' + out.shopping.map(function (s) { return '- ' + (s.amount + ' ' + s.unit).trim() + ' ' + s.name + (s.metric ? ' (' + s.metric + ')' : ''); }).join('\n');
      copy(text, 'Shopping list copied'); track('builder_shopping_list', { type: t.key });
    });
    r.querySelector('[data-act="share"]').addEventListener('click', function () { copy(location.href.split('#')[0] + key, 'Link copied'); track('builder_share', { type: t.key }); });
    r.querySelector('[data-act="print"]').addEventListener('click', function () { track('builder_print', { type: t.key }); window.print(); });
    if (els.vanillaNote && L.forms.length) els.vanillaNote.textContent = 'This dessert uses vanilla ' + L.forms.join(' and ') + '. The ' + (L.forms.indexOf('beans') !== -1 ? 'beans and extract' : 'extract') + ' these recipes call for:';
  }

  function copy(text, msg) {
    var done = function () { toast(msg); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () { fallback(); });
    else fallback();
    function fallback() { var ta = h('textarea', { style: 'position:fixed;left:-9999px' }); ta.value = text; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (e) { /* none */ } document.body.removeChild(ta); }
  }

  function save(out, key) {
    var s = ls(); if (!s) { toast('Saving needs browser storage turned on'); return; }
    var all = readSaves();
    if (all[key]) delete all[key];
    else all[key] = { n: out.title.slice(0, 200), u: (root.getAttribute('data-page') || location.pathname) + key, t: out.type.key, p: out.parts.map(function (p) { return p.handle; }).join(',').slice(0, 290), c: Date.now() };
    try { if (Object.keys(all).length) s.setItem(SAVE_KEY, JSON.stringify(all)); else s.removeItem(SAVE_KEY); } catch (e) { return; }
    track(all[key] ? 'builder_save' : 'builder_unsave', { type: out.type.key, title: out.title });
    toast(all[key] ? 'Saved to My Kitchen' : 'Removed from My Kitchen');
    renderSaved(); renderResult();
  }

  function renderSaved() {
    if (!els.saved) return;
    var all = readSaves(), keys = Object.keys(all).sort(function (a, b) { return (all[b].c || 0) - (all[a].c || 0); });
    els.savedBox.hidden = !keys.length;
    els.saved.innerHTML = keys.slice(0, 8).map(function (k) { return '<a href="' + esc(all[k].u) + '">' + esc(all[k].n) + '</a>'; }).join('') +
      (keys.length ? '<a href="/pages/my-kitchen">All in My Kitchen \u2192</a>' : '');
  }

  function renderGear() {
    var t = type();
    if (!els.gear || !t || !idx.data.gear[t.key] || !idx.data.gear[t.key].length) { if (els.gearBox) els.gearBox.hidden = true; return; }
    els.gear.innerHTML = idx.data.gear[t.key].map(function (g) {
      var p = photos[g.asin];
      return '<a href="https://www.amazon.com/dp/' + esc(g.asin) + '?tag=' + esc(idx.data.tag) + '" target="_blank" rel="sponsored noopener">' +
        '<span class="vgb-gear__img">' + (p ? '<img src="' + esc(p) + '" alt="" loading="lazy">' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h16v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zM2 11h2M20 11h2M9 6h6"/></svg>') + '</span>' +
        '<span>' + esc(g.name) + (g.why ? '<small>' + esc(g.why) + '</small>' : '') + '</span></a>';
    }).join('');
    els.gearBox.hidden = false;
  }

  /* ------------------------------------------------------------------ boot --- */

  fetch(root.getAttribute('data-data'), { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (data) {
    idx = C.index(data);
    if (els.count) els.count.textContent = data.components.length + ' components';
    state = C.fromHash(location.hash);
    if (state.type && !idx.types[state.type]) state = {};
    if (state.type && !state.servings) state.servings = idx.types[state.type].servings;
    Object.keys(state).forEach(function (k) { if (k !== 'type' && k !== 'servings' && state[k] && !idx.byHandle[state[k]]) delete state[k]; });
    renderClassics();
    renderSaved();
    render();
    window.addEventListener('hashchange', function () { var st = C.fromHash(location.hash); if (JSON.stringify(st) !== JSON.stringify(state)) { state = st; render(); } });
    window.addEventListener('storage', function (e) { if (e.key === SAVE_KEY) renderSaved(); });
  }).catch(function () {
    els.steps.innerHTML = '<li class="vgb-step"><div class="vgb-step__head"><h2>The builder could not load</h2></div><div class="vgb-step__body"><p>Please refresh the page. If it keeps happening, the recipes are all in <a href="/pages/recipes">recipe search</a>.</p></div></li>';
  });
})();
